<template>
  <div id="media-company">
    <div class="child-box contact-qq">
      <div class="title">大赛交流QQ群 ①：973875622</div>
      <div class="qq-code">
        <div class="QR-code">
          <img src="../assets/images/qr_code.png" />
        </div>
      </div>
      <div class="title">大赛交流QQ群 ②：673014907</div>
      <div class="qq-code">
        <div class="QR-code">
          <img src="../assets/images/qr_code2.png" />
        </div>
      </div>
    </div>
    <div class="child-box organizer">
      <div class="title">主办单位</div>
      <p>第九届全国高校数字艺术设计大赛组委会</p>
    </div>
    <div class="child-box hocooperative-unit">
      <div class="title">协办单位</div>
      <p>深圳市迷你玩科技有限公司、迷你学文化（深圳）有限公司</p>
    </div>
    <div class="child-box hocooperative-media">
      <div class="title">支持单位</div>
      <!-- <p v-for="(unit, u) in supportArr" :key="u">
        {{ unit }}
      </p> -->
      <p>
        NACG数字艺术人才培养工程办公室、未来设计师云平台、南方日报社、绝峰众创、火凤凰工作室
      </p>
    </div>
    <div class="child-box hocooperative-media">
      <div class="title">媒体支持</div>
      <p>
        NCDA大赛官方媒体、南方日报、南方都市报、南方周末、人民网、光明网、新华网、新浪、网易、腾讯新闻、南方网、奥一网
      </p>
      <!-- <p>南方日报</p> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Bottom',
  data() {
    return {
      supportArr: [
        'NACG数字艺术人才培养工程办公室',
        '未来设计师云平台',
        '南方报业传媒集团',
        '迷你学文化（深圳）有限公司'
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
#media-company {
  width: 750px;
  // height: 820px;
  // background: url('../assets/images/bg_media.jpg') no-repeat top center/750px
  //   820px;
  background-color: #3a3a3a;
  padding: 20px 20px 40px 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;

  color: #fff;
  p {
    font-size: 24px;
  }
  .child-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin-top: 20px;
    text-align: center;
    .title {
      font-size: 26px;
      font-weight: 600;
      margin-bottom: 10px;
    }
    .qq-code {
      display: flex;
      margin-left: 10px;

      .QR-code {
        width: 150px;
        height: 130px;
        background: url('../assets/images/bg_qq_code.png') no-repeat top
          center/124px 125px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 109px;
          height: 109px;
        }
      }
      .qq-group {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-left: 10px;
      }
    }
  }
}
</style>
